/** Whole-number percent; 0 when there is nothing to divide by, so a tile never says NaN. */
export function pct(part: number, whole: number): number {
  if (!(whole > 0)) return 0;
  return Math.round((part / whole) * 100);
}

/** Bar widths (0-100) relative to the largest count. */
export function barWidths(counts: number[]): number[] {
  const max = Math.max(0, ...counts);
  return counts.map((n) => (max > 0 ? Math.round((n / max) * 100) : 0));
}

export const fmtCount = (n: number) => n.toLocaleString("en-US");
